import { render, staticRenderFns } from "./trips-table.vue?vue&type=template&id=aadc6b6e"
import script from "./trips-table.vue?vue&type=script&lang=js"
export * from "./trips-table.vue?vue&type=script&lang=js"
import style0 from "./trips-table.vue?vue&type=style&index=0&id=aadc6b6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports